import React from 'react';

import SelectField from '../../../../components/inputs/selectField';
import FieldModal from '../../../../components/modals/fieldModal';

class GroupAttendeesModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			defaultGroupNames: [
				...props.groups.map((group) => {
					return { value: group._id, label: group.name, color: '#00B8D9' };
				})
			],
			groupNames: [
				...props.groups.map((group) => {
					return { value: group._id, label: group.name, color: '#00B8D9' };
				})
			],
			selectedValue: { label: '', color: '#00B8D9' },
			added: 0,
			submitting: false,
			invalid: false,
			success: false,
			newGroupChosen: false,
			requiredFields: {
				selectedValue: false
			}
		};
	}

	componentDidMount() {
		this.setState({});
	}

	reset = (e) => {
		this.setState({
			name: '',
			defaultGroupNames: [
				...this.props.groups.map((group) => {
					return { value: group._id, label: group.name, color: '#00B8D9' };
				})
			],
			groupNames: [
				...this.props.groups.map((group) => {
					return { value: group._id, label: group.name, color: '#00B8D9' };
				})
			],
			selectedValue: { label: '', color: '#00B8D9' },
			submitting: false,
			invalid: false,
			success: false
		});
		this.props.toggle();
	};

	handleNameChange = (e) => {
		const newGroup = {
			label: 'New group: ' + e,
			color: '#00B8D9',
			new: true
		};
		const filteredGRoupNames = this.state.defaultGroupNames.filter((group) => group.label.toLowerCase().includes(e.toLowerCase()));
		this.setState({
			groupNames: [...filteredGRoupNames, newGroup]
		});
	};

	handleGroupChosen = (e) => {
		if (e.new) {
			this.setState({ selectedValue: { ...e, label: e.label.split('New group: ')[1] }, newGroupChosen: true });
		} else {
			this.setState({ selectedValue: e });
		}
		/* if (e.value) {
			this.setState({
				groupNames: { 0: e.value }
			});
		} */
	};

	submit = () => {
		const { addGroup } = this.props;
		const { selectedValue } = this.state;

		const requiredFields = this.state.requiredFields;
		let valid = true;
		if ((!selectedValue.value || selectedValue.value === '') && !selectedValue.new) {
			requiredFields.selectedValue = true;
			valid = false;
		} else {
			requiredFields.selectedValue = false;
		}

		if (valid) {
			this.setState({ submitting: true });
			addGroup(selectedValue, (added) => {
				this.setState({ success: true, added: added });
			});
		} else {
			this.setState({ invalid: true, submitting: false });
		}
	};

	render() {
		const { isOpen, count } = this.props;
		const { groupNames, submitting, success, selectedValue, added, newGroupChosen, requiredFields } = this.state;

		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Add Attendees to Group"}
					bodyHeaderText={!success ? `You are adding ${count} ${count > 1 ? 'attendees' : 'attendee'} to this group` : <div>

						<b>
							{added} {`${added > 1 || added === 0 ? 'attendees ' : 'attendee'}`}
						</b>{' '}
						{`${added > 1 || added === 0 ? 'were' : 'was'}`} successfully added to group{' '}
						{selectedValue.label}

					</div>}
					bodyContent={() => {
						return (
							<div>
								{!success ? <SelectField
									label="Group Name"
									classes={'w-100'}
									value={selectedValue}
									errorTrigger={requiredFields.selectedValue}
									name="groupName"
									options={groupNames}
									required
									onChange={this.handleGroupChosen}
									onInputChange={this.handleNameChange}
								/>
									:
									""
								}
							</div>

						)
					}}
					toggle={this.reset}
					actionButtonLabel={!success ? !submitting ? 'Submit' : 'Updating...' : ''}
					cancelButtonLabel={success && 'Close'}

					actionButton={() => this.submit()}
					submitting={submitting}
					actionButtonDisabled={submitting || success}

				></FieldModal>
			</div>
		)

	}
}

export default GroupAttendeesModal;
